export enum AoInspectieOverspanningenScore {
    Onbekend = '0',
    Goed = '1',
    Matig = '2',
    Afgekeurd = '3',
    GevelAfgekeurd = '4',
}

export function conditionScoreToColorCode(conditionScore?: AoInspectieOverspanningenScore | null | string | number) {
    switch (conditionScore) {
        case AoInspectieOverspanningenScore.Goed:
            return '#70CA63';
        case AoInspectieOverspanningenScore.Matig:
            return '#FFC000';
        case AoInspectieOverspanningenScore.Afgekeurd:
            return '#FF0000';
        case AoInspectieOverspanningenScore.GevelAfgekeurd:
            return '#AA0000';
        default:
            return '#ECECEC';
    }
}

export function conditionScoreToText(conditionScore?: AoInspectieOverspanningenScore | null) {
    switch (conditionScore) {
        case AoInspectieOverspanningenScore.Goed:
            return 'Goed';
        case AoInspectieOverspanningenScore.Matig:
            return 'Matig';
        case AoInspectieOverspanningenScore.Afgekeurd:
            return 'Afgekeurd';
        case AoInspectieOverspanningenScore.GevelAfgekeurd:
            return 'Gevel afgekeurd';
        default:
            return '';
    }
}

export function getSelectOptions() {
    return [
        {
            value: AoInspectieOverspanningenScore.Goed,
            text: conditionScoreToText(AoInspectieOverspanningenScore.Goed),
        },
        {
            value: AoInspectieOverspanningenScore.Matig,
            text: conditionScoreToText(AoInspectieOverspanningenScore.Matig),
        },
        {
            value: AoInspectieOverspanningenScore.Afgekeurd,
            text: conditionScoreToText(AoInspectieOverspanningenScore.Afgekeurd),
        },
        {
            value: AoInspectieOverspanningenScore.GevelAfgekeurd,
            text: conditionScoreToText(AoInspectieOverspanningenScore.GevelAfgekeurd),
        },
    ];
}
